(() => {
  if (window.productGalleryVideoObserverInitialized) return;
  window.productGalleryVideoObserverInitialized = true;

  const videoSelector = '[data-type="video"] video[data-gallery-video]';

  function pauseGalleryVideos(gallery, activeVideo) {
    gallery.querySelectorAll(videoSelector).forEach((video) => {
      if (video !== activeVideo) video.pause();
    });
  }

  // Let the poster paint first: gallery videos start once the page has loaded (or after 1.5s at most).
  let startGateOpen = document.readyState === 'complete';
  const pendingVideos = new Set();

  function openStartGate() {
    if (startGateOpen) return;
    startGateOpen = true;
    pendingVideos.forEach((video) => {
      if (video.isConnected && !video.closest('.variant-image-hidden, .mobile-hidden')) startVideo(video);
    });
    pendingVideos.clear();
  }

  if (!startGateOpen) {
    window.addEventListener('load', openStartGate, { once: true });
    setTimeout(openStartGate, 1500);
  }

  function playVideo(video) {
    if (!startGateOpen) {
      pendingVideos.add(video);
      return;
    }
    startVideo(video);
  }

  function startVideo(video) {
    video.removeAttribute('controls');
    video.controls = false;

    if (video.dataset.poster) {
      video.poster = video.dataset.poster;
      delete video.dataset.poster;
    }

    const source = video.querySelector('source[data-src]');
    if (source) {
      source.src = source.dataset.src;
      delete source.dataset.src;
      video.load();
    }

    const playback = video.play();
    if (playback) {
      playback.catch((error) => {
        if (error.name !== 'NotAllowedError') {
          console.warn('Product gallery video playback failed.', error);
        }
      });
    }
  }

  function syncMobileGallery(gallery) {
    const slides = gallery.querySelector('.product__slides');
    if (!slides) return;

    const bounds = slides.getBoundingClientRect();
    let activeVideo = null;
    let activeRatio = 0;

    gallery.querySelectorAll(videoSelector).forEach((video) => {
      const slide = video.closest('[data-type="video"]');
      if (!slide || slide.closest('.variant-image-hidden, .mobile-hidden')) return;

      const rect = slide.getBoundingClientRect();
      const visibleWidth = Math.max(
        0,
        Math.min(rect.right, bounds.right) - Math.max(rect.left, bounds.left)
      );
      const visibleRatio = rect.width ? visibleWidth / rect.width : 0;

      if (visibleRatio > activeRatio) {
        activeRatio = visibleRatio;
        activeVideo = video;
      }
    });

    if (activeRatio < 0.5) activeVideo = null;
    pauseGalleryVideos(gallery, activeVideo);
    if (activeVideo) playVideo(activeVideo);
  }

  function observeGalleryScroll(gallery) {
    const slides = gallery.querySelector('.product__slides');
    if (!slides || slides.dataset.videoScrollObserved) return;

    slides.dataset.videoScrollObserved = 'true';
    let scrollTimeout;
    slides.addEventListener(
      'scroll',
      () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => syncMobileGallery(gallery), 80);
      },
      { passive: true }
    );
    slides.addEventListener('scrollend', () => syncMobileGallery(gallery), { passive: true });
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(({ isIntersecting, target: video }) => {
        if (!isIntersecting || video.closest('.variant-image-hidden, .mobile-hidden')) {
          pendingVideos.delete(video);
          video.pause();
          return;
        }

        const gallery = video.closest('product-images');
        if (gallery && window.matchMedia('(max-width: 749px)').matches) {
          syncMobileGallery(gallery);
        } else {
          playVideo(video);
        }
      });
    },
    { rootMargin: '0px', threshold: 0.5 }
  );

  function observeVideos(root = document) {
    root.querySelectorAll(videoSelector).forEach((video) => {
      observer.observe(video);
      const gallery = video.closest('product-images');
      if (gallery) observeGalleryScroll(gallery);
    });
  }

  observeVideos();

  new MutationObserver((mutations) => {
    mutations.forEach(({ addedNodes }) => {
      addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        if (node.matches(videoSelector)) observer.observe(node);
        observeVideos(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
